import { inject, Injectable } from "@angular/core";
import { Environment } from "../environments/environment.interface";
import { ENVIRONMENT } from "../environments/environments.token";

@Injectable({
  providedIn: "root",
})
export class StorageHandlerService {
  private env: Environment = inject(ENVIRONMENT);

  constructor() {}

  setItem(key: string, value: string) {
    if (this.env.IS_LOCAL_STORAGE) {
      localStorage.setItem(key, value);
    } else {
      sessionStorage.setItem(key, value);
    }
  }

  getItem(key: string): string {
    if (this.env.IS_LOCAL_STORAGE) {
      return localStorage.getItem(key) || "";
    } else {
      return sessionStorage.getItem(key) || "";
    }
  }

  deleteItem(key: string) {
    if (this.env.IS_LOCAL_STORAGE) {
      localStorage.removeItem(key);
    } else {
      sessionStorage.removeItem(key);
    }
  }

  clearAll() {
    if (this.env.IS_LOCAL_STORAGE) {
      localStorage.clear();
    } else {
      sessionStorage.clear();
    }
  }
}
